/* eslint-disable  */

import { LocaleMessages } from '~/types/i18n'

const messages: LocaleMessages = {

}

export default messages
